export const version = { buildDate: '05.11.2026 07:58' };